import api from './api';

// Busca o guia de cultivo de uma planta (usa a IA do backend).
// mode: 'fotoperiodo' | 'automatica' (opcional); vasoL: tamanho do vaso em litros.
// environment: 'indoor' | 'outdoor' (ajusta rega/luz/colheita conforme estudo).
export async function getPlantGuide(query, mode, vasoL, environment) {
    const { data } = await api.post('/ai/plant-guide', { query, mode, vasoL, environment });
    return data;
}

// Aplica o guia de cultivo às configurações do controlador (device).
export async function applyGuideToDevice(deviceId, query, mode, vasoL, environment) {
    const { data } = await api.post('/ai/apply-to-device', { deviceId, query, mode, vasoL, environment });
    return data;
}

// Lista sugestões de plantas disponíveis no dataset local.
export async function getPlantSuggestions() {
    try {
        const { data } = await api.get('/ai/plant-suggestions');
        return data.suggestions || [];
    } catch {
        return [];
    }
}

// Busca plantas no guia de cultivo por termo (autocomplete digitável).
// Retorna [{ key, nome, modo }].
export async function searchPlantGuides(q) {
    try {
        const { data } = await api.get('/ai/plant-search', { params: { q } });
        return data.results || [];
    } catch {
        return [];
    }
}
